import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import {
  formatDate,
  getSearchApiDateFormat,
} from "../../../utility/common-methods.jsx";
import {
  FILTER_NAMES,
  DATE_FORMATS,
  VERTICALS,
  REGIONAL_LANGUAGE,
} from "../../../constants/app-constant";
import {
  SOCIAL_SOURCES_OPTIONS,
  SOCIAL_SOURCES,
  TONALITY_FILTER,
} from "../../../constants/static-filter";
import {
  ONLINE_SOURCE_LIST,
  PRINT_SOURCE_LIST,
  ALL_SOURCE_LIST,
} from "../../../constants/static-filter";
import { Input } from "../../Shared/FormElements/Input.jsx";
import {
  CloseIcon,
  DownloadBlueIcon,
  ArrowDownIcon,
} from "../../Icons/icons.component";
import { FilterItem } from "./FilterItem.jsx";
import {
  fetchPublicationIds,
  resetPublications,
} from "../../../actions/filters-actions";
import PublicationFilter from "./FilterGroups/PublicationFilter.jsx";
import SourceFilter from "./FilterGroups/SourceFilter.jsx";
import DateRangeFilter from "./DateRangeFilter.jsx";
import SocialFilterItem from "../../NewsAndAnalysis/Filters/SocialFilterItem";
import { Dropdown } from "react-bootstrap";
import { httpPost } from "../../../utility/requestHelper.js";
import { envConfig } from "../../../constants/api-endpoint.js";

const {
  EDITION,
  PUBLICATION_TYPE,
  SOURCE_TYPE,
  RANGE,
  TONALITY,
  ZONE,
  ENTITY,
  CATEGORY,
  HEADLINE,
  PUBLICATION_IDS,
  CLIENT,
  VERTICAL,
  TYPED_PUBLICATION_TEXT,
  REMOVE_PUBLICATION_TEXT,
  REPORTER,
  TYPED_REPORTER_TEXT,
  REMOVE_REPORTER_TEXT,
  PRESS_RELEASE,
  KEYWORDS_SEARCH,
  CHANNELS,
  LANGUAGES,
  COUNTRIES,
  PLATFORM,
  TONALITY_MULT,
  REPORT_LIST,
  LANGUAGE_LIST,
  CHANNELS_LIST,
  CHART_TYPE,
} = FILTER_NAMES;
const {
  V_PRINT,
  V_ONLINE,
  V_SOCIAL,
  V_PRINT_AND_ONLINE_OLD,
  V_BLOG,
  V_FORUM,
  V_BLOGS_AND_FORUMS,
} = VERTICALS;
const Filters = ({
  applyFilters,
  filters,
  setFilters,
  setRangeForApi,
  toggleFilter,
  defaultEntityId,
  client_id,
  selectedVertical,
  initEntityFilter,
  renderDownloadIcon,
  startRange,
  endRange,
  isAnalysisMain,
  hideDateRange,
  entityFilterList,
  countryList,
  languageList,
  selectedClient,
  selectedTab,
  initLanguageFilter,
  initPlatformFilter,
  initTonalityFilter,
  handleResetFilters,
  setApplyFilters,
  setSelectAll,
  selectedAll,
  isTV,
  selectedChartType,
  setSelectedChartType,
  chartTypeList,
}) => {
  //names of these filters shall be same as the corresponding key in the api response.  q q
  const [selectedFilter, setSelectedFilter] = useState(undefined);
  const [bufferDateStart, setBufferDateStart] = useState(startRange);
  const [bufferDateEnd, setBufferDateEnd] = useState(endRange);
  const [favourite, setFavourite] = useState(false);
  const [isResetFilter, setIsResetFilter] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const filterState = useSelector((state) => state.filterReducer);
  const IsSocialFlag =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.configuration
    ) || {};
  const entityData = filterState && filterState.entityFilter;

  const entityFilter =
    entityFilterList && entityFilterList.values.length > 0
      ? entityFilterList
      : entityData;
  const {
    publicationTypeFilter,
    zoneFilter,
    editionFilter,
    categoryFilter,
    verticalFilter,
    tonalityFilter,
    blogAndForumVerticalFilter,
  } = filterState;
  const pressReleaseList =
    useSelector((state) => state.filterReducer.press_release) || [];
  const channels = useSelector((state) => state.filterReducer.channelsFilter);
  const reports = useSelector((state) => state.filterReducer.reporterFilter);
  const languages = useSelector((state) => state.filterReducer.languageFilter);
  const clientLanguages = useSelector((state) => state.clientReducer.clientLanguage);
  const stateList = useSelector((state) => state.clientReducer.state);

  const sourceList =
    // eslint-disable-next-line
    selectedVertical == V_PRINT_AND_ONLINE_OLD
      ? ALL_SOURCE_LIST
      : selectedVertical == V_ONLINE
      ? ONLINE_SOURCE_LIST
      : PRINT_SOURCE_LIST;

  const dispatch = useDispatch();
  const { media_type, source_type } = filters;

  const vRef = useRef(true);
  const srcRef = useRef(true);

  useEffect(() => {
    dispatch(fetchPublicationIds(selectedVertical));
  }, []);

  useEffect(() => {
    const today = new Date();
    const tempDateObj = {
      startDate: moment(today).format("yyyy/MM/DD"),
      endDate: moment(today).format("yyyy/MM/DD"),
    };
    if (vRef.current) {
      vRef.current = false;
      return;
    }
    handleVerticalChange();
    dispatch(fetchPublicationIds(getCorrectVertical()));
    if (isResetFilter) {
      applyFilters(null, null, tempDateObj);
      setIsResetFilter(false);
      toggleFilter(false);
    }
  }, [selectedVertical, media_type]);

  useEffect(() => {
    setBufferDateEnd(endRange);
    setBufferDateStart(startRange);
  }, [endRange, startRange]);
  useEffect(() => {
    setFilters((prevFilters) => {
      return {
        ...prevFilters,
        favourite,
      };
    });
  }, [favourite]);
  useEffect(() => {
    if (srcRef.current) {
      srcRef.current = false;
      return;
    } else {
      handleFilterSelect(FILTER_NAMES.REPORTER, "", true);
    }
  }, [source_type]);

  const getCorrectVertical = () => {
    if (!isTV) {
      const { media_type } = filters;
      const isPrintSelected = media_type.indexOf(V_PRINT) !== -1;
      const isOnlineSelected = media_type.indexOf(V_ONLINE) !== -1;
      const isBothSelected = (isOnlineSelected && isPrintSelected) || (media_type.indexOf(V_PRINT_AND_ONLINE_OLD) !== -1);
      if (isBothSelected) {
        return V_PRINT_AND_ONLINE_OLD;
      }
      if (isOnlineSelected) {
        return V_ONLINE;
      }
      if (isPrintSelected) {
        return V_PRINT;
      }
    }
  };

  const handleVerticalChange = () => {
    setFilters({
      edition: [],
      publication_type: [],
      publication: [],
      tonality: "",
      zone: "",
      entity: filters.entity,
      media_type: filters.media_type,
      category: "",
      client: "",
      headline: "",
      keywords: [],
      typedPublication: "",
      typedReporter: "",
      reporter: "",
      source_type: "",
      press_release: [],
      platform: [],
      languages: IsSocialFlag?.configuration?.language_metadata?(IsSocialFlag?.configuration?.language_metadata?.split(",")):Object.keys(REGIONAL_LANGUAGE),
      country: "",
      favourite: false,
    });
  };

  const handleResetAll = () => {
    !isAnalysisMain && setApplyFilters(true);
    setIsResetFilter(true);
    const defaultDate = getSearchApiDateFormat();
    let defaultVertical = [];
    if (selectedTab == V_SOCIAL) {
      defaultVertical = [V_SOCIAL];
    } else if (selectedTab == V_BLOGS_AND_FORUMS) {
      defaultVertical = blogAndForumVerticalFilter.values.map((e) => e.id);
    } else {
      defaultVertical = verticalFilter.values.map((e) => e.id);
    }
    setFilters({
      edition: [],
      publication_type: [],
      publication: [],
      tonality: [],
      zone: "",
      entity: entityFilter.values.map((e) => e.id),
      media_type: defaultVertical,
      category: "",
      client: "",
      headline: "",
      keywords: [],
      typedPublication: "",
      typedReporter: "",
      reporter: "",
      source_type: "",
      press_release: [],
      platform: [],
      languages: IsSocialFlag?.configuration?.language_metadata?(IsSocialFlag?.configuration?.language_metadata?.split(",")):Object.keys(REGIONAL_LANGUAGE),
      country: "",
      favourite: false,
    });
    setRangeForApi &&
      setRangeForApi({
        start: defaultDate,
        end: defaultDate,
      });
    !isAnalysisMain && window.location.reload();
  };

  const handleFilterSelect = (name, value, resetAll, selectAll) => {
    switch (name) {
      case CHANNELS_LIST: {
        if (resetAll) {
          setFilters({ ...filters, channels: "" });
          return;
        }
        setFilters({ ...filters, channels: value });
        break;
      }

      case LANGUAGES: {
        if (resetAll) {
          setFilters({ ...filters, languages: "" });
          return;
        }
        let tFilter = {...filters}
        if(tFilter.languages.includes(value)){
          setFilters({ ...filters, languages: tFilter.languages.filter((data) => data !== value) });
        }
        else{
          setFilters({ ...filters, languages: [...filters.languages,...[value]] });
        }
        break;
      }
      case "State": {
        if (resetAll) {
          setFilters({ ...filters, state: "" });
          return;
        }
        
        httpPost(
              `${envConfig.SEARCH_STATE}`,
              // `${unifiedEnvConfig.PRINT_LIST_COUNT}`,
              {state_id:value}
            )
              .then((res) => {
                const {
                  data: { result },
                } = res || {};
                setFilters({ ...filters, ...{edition: result.map(rData => rData.id),state: value}});
                // resolve(result.data);
              })
              .catch((e) => {
                // reject(e);
              });
        // let tFilter = {...filters}
        // console.log(tFilter.languages,value,"kine 308")
        // if(tFilter.languages.includes(value)){
        //   setFilters({ ...filters, languages: tFilter.languages.filter((data) => data !== value) });
        // }
        // else{
        //   setFilters({ ...filters, languages: [...filters.languages,...[value]] });
        // }
        break;
      }
      case "JOURNALIST": {
        if (resetAll) {
          setFilters({ ...filters, anchor: "" });
          return;
        }
        setFilters({ ...filters, anchor: value });
        break;
      }
      case EDITION: {
        if (resetAll) {
          setFilters({ ...filters, edition: [] });
          return;
        }
        let tFilter = {...filters}
        // if(value == ""){
        //   if(tFilter.edition.length){
        //     setFilters({ ...filters, edition: [] });
        //   }
        //   else{
        //     setFilters({ ...filters, edition: editionFilter.values.map((eData) => eData.id) });
        //   }
        // }
        if(tFilter.edition.includes(value)){
          setFilters({ ...filters, edition: tFilter.edition.filter((data) => data !== value) });
        }
        else{
          setFilters({ ...filters, edition: [...filters.edition,...[value]] });
        }
        // setFilters({ ...filters, edition: value });
        break;
      }

      case PUBLICATION_TYPE: {
        if (resetAll) {
          setFilters({
            ...filters,
            publication_type: [],
            typedPublication: "",
            publication: [],
          });
          return;
        }
        const tempPublicationType = filters.publication_type
          ? [...filters.publication_type]
          : [];
        const elmIndex = tempPublicationType.indexOf(value);
        if (elmIndex === -1) {
          tempPublicationType.push(value);
          setFilters({ ...filters, publication_type: tempPublicationType });
        } else {
          tempPublicationType.splice(elmIndex, 1);
          setFilters({ ...filters, publication_type: tempPublicationType });
        }
        break;
      }

      case SOURCE_TYPE: {
        if (resetAll) {
          setFilters({ ...filters, source_type: "" });
          return;
        }
        setFilters({ ...filters, source_type: value });
        break;
      }

      case RANGE:
        const { start, end } = value || {};
        if (start && end) {
          setRangeForApi({
            start: formatDate(start, DATE_FORMATS.YYYYMMDD_slash),
            end: formatDate(end, DATE_FORMATS.YYYYMMDD_slash),
          });
        }
        break;

      case TONALITY: {
        if (resetAll) {
          setFilters({ ...filters, tonality: "" });
          return;
        }
        setFilters({ ...filters, tonality: value });

        break;
      }

      case CHART_TYPE: {
        setFilters({ ...filters, chartType: value });
        break;
      }
      case ZONE: {
        if (resetAll) {
          setFilters({ ...filters, zone: "" });
          return;
        }
        setFilters({ ...filters, zone: +value });
        break;
      }
      case ENTITY: {
        const { entity = [] } = filters;
        if (selectAll) {
          setSelectAll(true);
          initEntityFilter();
          return;
        }
        if (resetAll) {
          setSelectAll(false);
          initEntityFilter();
          return;
        }
        const tempEntity = entity ? [...entity] : [];
        const elmIndex = tempEntity.indexOf(value);
        if (elmIndex === -1) {
          tempEntity.push(value);
          setFilters({ ...filters, entity: tempEntity });
        } else {
          tempEntity.splice(elmIndex, 1);
          setFilters({ ...filters, entity: tempEntity });
        }
        break;
      }
      case CLIENT: {
        if (resetAll) {
          setFilters({ ...filters, client: "" });
          return;
        }
        const tempClient = [...filters.client];
        const elmIndex = tempClient.indexOf(value);
        if (elmIndex === -1) {
          tempClient.push(value);
          setFilters({ ...filters, client: tempClient });
        } else {
          tempClient.splice(elmIndex, 1);
          setFilters({ ...filters, client: tempClient });
        }
        break;
      }

      case VERTICAL: {
        if (resetAll) {
          setFilters({ ...filters, media_type: [] });
          return;
        }
        const tempVertical = [...filters.media_type];
        const oldIndex = tempVertical.indexOf(V_PRINT_AND_ONLINE_OLD);
        if (oldIndex !== -1) {
          tempVertical.splice(oldIndex, 1);
        }
        const elmIndex = tempVertical.indexOf(value);
        if (elmIndex === -1) {
          tempVertical.push(value);
          setFilters({ ...filters, media_type: tempVertical });
        } else {
          tempVertical.splice(elmIndex, 1);
          setFilters({ ...filters, media_type: tempVertical });
        }
        break;
      }

      case CATEGORY: {
        if (resetAll) {
          setFilters({ ...filters, category: "" });
          return;
        }
        setFilters({ ...filters, category: value });
        break;
      }

      case HEADLINE: {
        if (resetAll) {
          setFilters({ ...filters, headline: "" });
          return;
        }
        setFilters({ ...filters, headline: value });
        break;
      }

      case PUBLICATION_IDS: {
        const { publication } = filters;
        if (resetAll) {
          setFilters({ ...filters, publication: "", typedPublication: "" });
          return;
        }
        if (publication && publication.filter((e) => e.id === value.id)[0]) {
          return;
        }
        const currentPublication = publication || [];
        setFilters({
          ...filters,
          publication: [...currentPublication, value],
          typedPublication: "",
        });
        dispatch(resetPublications());
        break;
      }

      case TYPED_PUBLICATION_TEXT: {
        setFilters({ ...filters, typedPublication: value });
        break;
      }

      case REMOVE_PUBLICATION_TEXT: {
        const updatedArr =
          filters.publication &&
          filters.publication.filter((e) => e.id !== value.id);
        setFilters({ ...filters, publication: updatedArr });
        break;
      }

      case REMOVE_REPORTER_TEXT: {
        const { reporter } = filters;
        const updatedArr =
          reporter && reporter.filter((e) => e.id !== value.id);
        setFilters({ ...filters, reporter: updatedArr });
        break;
      }

      case REPORTER: {
        const { reporter = [] } = filters;

        if (resetAll) {
          setFilters({ ...filters, reporter: [] });
          return;
        }
        if (
          reporter &&
          Array.isArray(reporter) &&
          reporter.filter((e) => e.id === value.id)[0]
        ) {
          return;
        }
        setFilters({
          ...filters,
          reporter: [...reporter, value],
          typedReporter: "",
        });
        break;
      }

      case TYPED_REPORTER_TEXT: {
        setFilters({ ...filters, typedReporter: value });
        break;
      }

      case KEYWORDS_SEARCH: {
        if (resetAll) {
          setFilters({ ...filters, keywords: "" });
          return;
        }
        setFilters({ ...filters, keywords: value });
        break;
      }

      case PRESS_RELEASE: {
        if (resetAll) {
          setFilters({ ...filters, press_release: "" });
          return;
        }
        setFilters({ ...filters, press_release: value });
        break;
      }
      case PLATFORM: {
        if (selectAll) {
          setSelectAll(true);
          initPlatformFilter();
          return;
        }
        const { platform = [] } = filters;
        if (resetAll) {
          setSelectAll(false);
          initPlatformFilter();
          return;
        }
        const tempPlatform = platform ? [...platform] : [];
        const elmIndex = tempPlatform.indexOf(value);
        if (elmIndex === -1) {
          tempPlatform.push(value);
          setFilters({ ...filters, platform: tempPlatform });
        } else {
          tempPlatform.splice(elmIndex, 1);
          setFilters({ ...filters, platform: tempPlatform });
        }
        break;
      }

      case LANGUAGES: {
        if (selectAll) {
          setSelectAll(true);
          initLanguageFilter();
          return;
        }
        const { languages = [] } = filters;
        if (resetAll) {
          setSelectAll(false);
          initLanguageFilter();
          return;
        }
        const tempLanguages = languages ? [...languages] : [];
        const elmIndex = tempLanguages.indexOf(value);
        if (elmIndex === -1) {
          tempLanguages.push(value);
          setFilters({ ...filters, languages: tempLanguages });
        } else {
          tempLanguages.splice(elmIndex, 1);
          setFilters({ ...filters, languages: tempLanguages });
        }
        break;
      }
      case TONALITY_MULT: {
        const { tonality = [] } = filters;
        if (selectAll) {
          setSelectAll(true);
          initTonalityFilter();
          return;
        }
        if (resetAll) {
          setSelectAll(false);
          initTonalityFilter();
          return;
        }
        const tempTonality = tonality ? [...tonality] : [];
        const elmIndex = tempTonality.indexOf(value);
        if (elmIndex === -1) {
          tempTonality.push(value);
          setFilters({ ...filters, tonality: tempTonality });
        } else {
          tempTonality.splice(elmIndex, 1);
          setFilters({ ...filters, tonality: tempTonality });
        }
        break;
      }
      case COUNTRIES: {
        if (resetAll) {
          setFilters({ ...filters, country: "" });
          return;
        }
        setFilters({ ...filters, country: value });
        break;
      }
      default:
    }
  };
  useEffect(() => {
    setDisabled(
      moment(bufferDateEnd).diff(bufferDateStart, "months", true) <= 1
    );
  }, [bufferDateStart, bufferDateEnd]);
  const handleBufferDateChange = (date, type) => {
    const formattedDate = date;
    if (type === "start") {
      setBufferDateStart(formattedDate);
    } else {
      setBufferDateEnd(formattedDate);
    }
  };

  let tempDateObj = {
    startDate: moment(bufferDateStart).format("yyyy/MM/DD"),
    endDate: moment(bufferDateEnd).format("yyyy/MM/DD"),
  };
  const isSocial = selectedTab == V_SOCIAL;
  const isBlogAndForum = selectedTab == V_BLOGS_AND_FORUMS;
  const isPrintAndOnline = () => selectedTab == V_PRINT_AND_ONLINE_OLD;
  const isOnlineOnly = getCorrectVertical() == V_ONLINE;
  const isPrintOnly = getCorrectVertical() == V_PRINT;

  return (
    <React.Fragment key={selectedTab}>
      <div className="filtersWrap sideFilterWrap">
        <div className="filtersHeader d-flex">
          <h4>Filters</h4>
          <button onClick={() => toggleFilter(false)} className="closeIconWrap">
            <CloseIcon />
          </button>
        </div>
        <div className="filterReset">
          <button onClick={() => handleResetAll()} className="btn resetAllBtn">
            Reset Filters
          </button>
        </div>
        <div className="filtersColumnWrap">
          {!hideDateRange && (
            <DateRangeFilter
              key="filter-internal"
              handleDateChange={handleBufferDateChange}
              startRange={bufferDateStart}
              endRange={bufferDateEnd}
              minDate={selectedClient ? selectedClient.start_date : null}
              maxDate={selectedClient ? selectedClient.end_date : null}
            />
          )}
          {chartTypeList && (
            <FilterItem
              filters={filters}
              filterOption={{
                values: chartTypeList,
                name: CHART_TYPE,
                multiselect: false,
              }}
              selectedFilter={selectedChartType}
              setSelectedFilter={setSelectedChartType}
              handleFilterSelect={handleFilterSelect}
            />
          )}
          <FilterItem
            filters={filters}
            setSelectedFilter={setSelectedFilter}
            selectedFilter={selectedFilter}
            handleFilterSelect={handleFilterSelect}
            filterOption={entityFilter}
            showSelectedAll
          />

          {isTV && (
            <>
              <FilterItem
                filters={filters}
                setSelectedFilter={setSelectedFilter}
                selectedFilter={selectedFilter}
                handleFilterSelect={handleFilterSelect}
                filterOption={channels}
              />
              <FilterItem
                filters={filters}
                setSelectedFilter={setSelectedFilter}
                selectedFilter={selectedFilter}
                handleFilterSelect={handleFilterSelect}
                filterOption={reports}
              />
              <FilterItem
                filters={filters}
                setSelectedFilter={setSelectedFilter}
                selectedFilter={selectedFilter}
                handleFilterSelect={handleFilterSelect}
                filterOption={languages}
              />
            </>
          )}
          {/* print and online filters */}
          {isPrintAndOnline() && (
            <>
              <FilterItem
                filters={filters}
                setSelectedFilter={setSelectedFilter}
                selectedFilter={selectedFilter}
                handleFilterSelect={handleFilterSelect}
                filterOption={verticalFilter}
                isAddWidgetPage
                showNone={false}
              />
              {selectedClient.id == "11717"?
                <FilterItem
                  filters={filters}
                  setSelectedFilter={setSelectedFilter}
                  selectedFilter={selectedFilter}
                  handleFilterSelect={handleFilterSelect}
                  filterOption={{
                    name: LANGUAGES,
                    values : clientLanguages,
                    multiselect : true
                  }}
                  showNone={false}
                />
              :""}
              {isAnalysisMain && isOnlineOnly ? null : (
                <>
                  <PublicationFilter
                    filters={filters}
                    setSelectedFilter={setSelectedFilter}
                    selectedFilter={selectedFilter}
                    handleFilterSelect={handleFilterSelect}
                    filterOption={publicationTypeFilter}
                    client_id={client_id}
                    selectedVertical={selectedVertical}
                  />
                  {selectedClient.id == 11717?
                  <>
                    <FilterItem
                      filters={filters}
                      setSelectedFilter={setSelectedFilter}
                      selectedFilter={selectedFilter}
                      handleFilterSelect={handleFilterSelect}
                      filterOption={{
                        name: "State",
                        values : stateList,
                        multiselect : false
                      }}
                      showSelectedAll
                    />
                  </>
                  :""}
                  <FilterItem
                    filters={filters}
                    setSelectedFilter={setSelectedFilter}
                    selectedFilter={selectedFilter}
                    handleFilterSelect={handleFilterSelect}
                    filterOption={{...editionFilter,...{multiselect : true}}}
                    // showSelectedAll
                  />
                </>
              )}
              {isAnalysisMain && (
                <FilterItem
                  filters={filters}
                  setSelectedFilter={setSelectedFilter}
                  selectedFilter={selectedFilter}
                  handleFilterSelect={handleFilterSelect}
                  filterOption={TONALITY_FILTER}
                  showSelectedAll
                />
              )}
              <FilterItem
                filterOption={{
                  multiselect: false,
                  name: PRESS_RELEASE,
                  values: pressReleaseList,
                }}
                setSelectedFilter={setSelectedFilter}
                filters={filters}
                handleFilterSelect={handleFilterSelect}
                selectedFilter={selectedFilter}
                showSelectedAll
              />
            </>
          )}
          {/* social filters */}
          {(isSocial || isBlogAndForum) && (
            <>
              {isBlogAndForum && (
                <FilterItem
                  filters={filters}
                  setSelectedFilter={setSelectedFilter}
                  selectedFilter={selectedFilter}
                  handleFilterSelect={handleFilterSelect}
                  filterOption={blogAndForumVerticalFilter}
                  isAddWidgetPage
                  showNone={false}
                />
              )}
              {!isBlogAndForum && (
                <FilterItem
                  filters={filters}
                  setSelectedFilter={setSelectedFilter}
                  selectedFilter={selectedFilter}
                  handleFilterSelect={handleFilterSelect}
                  filterOption={{
                    name: "PLATFORM",
                    values: [...SOCIAL_SOURCES_OPTIONS],
                    multiselect: true,
                  }}
                  showSelectedAll
                />
              )}
              <FilterItem
                filters={filters}
                setSelectedFilter={setSelectedFilter}
                selectedFilter={selectedFilter}
                handleFilterSelect={handleFilterSelect}
                filterOption={TONALITY_FILTER}
                showSelectedAll
              />
              <FilterItem
                filters={filters}
                setSelectedFilter={setSelectedFilter}
                selectedFilter={selectedFilter}
                handleFilterSelect={handleFilterSelect}
                filterOption={{
                  name: "LANGUAGES",
                  values: languageList,
                  multiselect: true,
                }}
                showSelectedAll
              />
              <FilterItem
                filters={filters}
                setSelectedFilter={setSelectedFilter}
                selectedFilter={selectedFilter}
                handleFilterSelect={handleFilterSelect}
                filterOption={{
                  name: COUNTRIES,
                  values: countryList,
                  multiselect: false,
                }}
                showSelectedAll
              />
            </>
          )}
          {!isAnalysisMain && !isTV && (
            <FilterItem
              filters={filters}
              setSelectedFilter={setSelectedFilter}
              selectedFilter={selectedFilter}
              handleFilterSelect={handleFilterSelect}
              filterOption={zoneFilter}
            />
          )}
          {!isAnalysisMain && !isTV && (
            <>
              {/* <FilterItem
                filterOption={{
                  multiselect: false,
                  name: SOURCE_TYPE,
                  values: sourceList,
                }}
                setSelectedFilter={setSelectedFilter}
                filters={filters}
                handleFilterSelect={handleFilterSelect}
                selectedFilter={selectedfilter}
              /> */}
              <SourceFilter
                filters={filters}
                handleFilterSelect={handleFilterSelect}
                selectedVertical={selectedVertical}
              />
            </>
          )}
          {!isAnalysisMain && (
            <FilterItem
              filters={filters}
              setSelectedFilter={setSelectedFilter}
              selectedFilter={selectedFilter}
              handleFilterSelect={handleFilterSelect}
              filterOption={categoryFilter}
            />
          )}
          {!isAnalysisMain && (
            <FilterItem
              filters={filters}
              setSelectedFilter={setSelectedFilter}
              selectedFilter={selectedFilter}
              handleFilterSelect={handleFilterSelect}
              filterOption={tonalityFilter}
            />
          )}
          {!isAnalysisMain && (
            <FilterItem
              filters={filters}
              setSelectedFilter={setSelectedFilter}
              selectedFilter={selectedFilter}
              handleFilterSelect={handleFilterSelect}
              filterOption={{
                name: "LANGUAGE",
                values: languageList,
                multiselect: true,
              }}
            />
          )}
          {!isAnalysisMain && (
            <FilterItem
              filters={filters}
              setSelectedFilter={setSelectedFilter}
              selectedFilter={selectedFilter}
              handleFilterSelect={handleFilterSelect}
              filterOption={{
                name: "COUNTRY",
                values: countryList,
                multiselect: false,
              }}
            />
          )}
          {!isAnalysisMain && (
            <>
              <div className="form-group">
                <div className="filterDiv filteInputText searchField">
                  <Input
                    id="headline-filter"
                    type="text"
                    onChange={(value) => {
                      handleFilterSelect(HEADLINE, value);
                    }}
                    value={filters.headline}
                    placeholder="Search by Headline"
                  ></Input>
                </div>
              </div>
              {!isTV && (
                <div className="form-group">
                  <div className="filterDiv filteInputText searchField">
                    <Input
                      id="keyword-filter"
                      type="text"
                      onChange={(value) => {
                        handleFilterSelect(KEYWORDS_SEARCH, value);
                      }}
                      value={filters.keywords}
                      placeholder="Search by Keywords"
                    ></Input>
                  </div>
                </div>
              )}
            </>
          )}

          {!isAnalysisMain && !isTV && (
            <div className="form-group showFavourited">
              <label className="inputWrap">
                Show Favourited
                <input
                  type="checkbox"
                  checked={favourite}
                  onClick={(e) => setFavourite(e.target.checked)}
                />
                <span className="checkmark"></span>
              </label>
            </div>
          )}
          <div className="form-group form-action text-right">
            {!isAnalysisMain &&
              !isTV &&
              [
                VERTICALS.V_ONLINE,
                VERTICALS.V_PRINT,
                VERTICALS.V_PRINT_AND_ONLINE_OLD,
              ].indexOf(selectedVertical) !== -1 &&
              renderDownloadIcon({ ...tempDateObj, title: "Download" }, true)}
            {isTV &&
              renderDownloadIcon({ ...tempDateObj, title: "Download" }, true)}
            <button
              className="btn btnBlue"
              onClick={(e) => {
                toggleFilter(false);
                applyFilters(e, false, isAnalysisMain ? null : tempDateObj);
              }}
              disabled={!disabled}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Filters;
